import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
  LocationSelect,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, logo, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          justifyStart
          alignCenter
          textCenter
        >
          <CFImage
            mt="5%"
            w="92%"
            maxWidth="320px"
            src={mobileHeroText}
            alt="Tsuki Sushi hero text"
            zIndex={98}
          />
          <LocationSelect />
          {/* <CFView
            mt="10px"
            ml="10px"
            center
            br="30px"
            bc="white"
            bw="3px"
            pv="5px"
            ph="15px"
            zIndex={99}
          >
            <CFView h2 color="white" xBold mb="2px">
              VANCOUVER LOCATION
            </CFView>
          </CFView> */}
          <CFView mb="20px">
            <CFView mt="25px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) right / cover no-repeat`}
          zIndex={90}
          column
          center
          justifyBetween
        >
          <Header />
          <CFView
            bg="rgba(0,0,0,.7)"
            row
            justifyStart
            alignCenter
            w="80%"
            minWidth="800px"
          >
            <CFView white style={{ fontSize: 30 }} pl="25px" xBold>
              Welcome to Tsuiki Sushi
            </CFView>
            <CFView color="red" style={{ fontSize: 30 }} ph="7px" xBold>
              Coquitlam
            </CFView>
            <CFView white style={{ fontSize: 30 }} pr="25px" xBold>
              Location!
            </CFView>
            <CFView pulsate mt="5px" pv="3px" pr="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
